import React, { useState, useEffect } from 'react';
import './style/Slider.css';
import CardProductSlider from './CardProductSlider';
import axios from 'axios';
import BottomModal from './BottomModal';

const Slider = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showAddedMessage, setShowAddedMessage] = useState(false);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}v1/products`, {
                    headers: {
                        'x-api-key': '12345xxa'
                    }
                });
                setProducts(response.data);
            } catch (error) {
                console.error("Ошибка при получении данных о продуктах:", error);
            }
        };
        fetchProducts();
    }, []);

    const openModal = (product) => {
        setSelectedProduct(product);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedProduct(null);
    };

    const handleAddToCart = () => {
        setShowAddedMessage(true);
        setTimeout(() => {
            setShowAddedMessage(false);
        }, 2000);
    };

    const nextSlide = () => {
        if (currentIndex < products.length - 5) { // Adjust the number 5 to the number of visible items
            setCurrentIndex((prevIndex) => prevIndex + 1);
        }
    };

    const prevSlide = () => {
        if (currentIndex > 0) {
            setCurrentIndex((prevIndex) => prevIndex - 1);
        }
    };

    return (
        <div className="slider">
            {showAddedMessage && (
                <div className="global-added-message">Товар добавлен в корзину</div>
            )}
            <button className="slider__button slider__button--left" onClick={prevSlide} disabled={currentIndex === 0}>
                &#10094;
            </button>
            <div className="slider__content" style={{ transform: `translateX(-${currentIndex * 20}%)` }}>
                {products.map((product) => (
                    <div className="slider__item" key={product.id}>
                        <CardProductSlider product={product} openModal={openModal} handleAddToCart={handleAddToCart} />
                    </div>
                ))}
            </div>
            <button className="slider__button slider__button--right" onClick={nextSlide} disabled={currentIndex >= products.length - 5}>
                &#10095;
            </button>
            {selectedProduct && (
                <BottomModal isOpen={isModalOpen} onClose={closeModal} product={selectedProduct} />
            )}
        </div>
    );
};

export default Slider;
